import { useContext } from "react";
import LogViewLayoutContext from "logview/components/contexts/LogViewLayoutContext";
const useLogViewLayout = () => {
  const logViewLayout = useContext(LogViewLayoutContext);
  if (!logViewLayout) {
    throw new Error("useLogViewLayout hook needs to be used inside LogViewLayoutContext.Provider");
  }
  return logViewLayout;
};
export default useLogViewLayout;
